import { Box, BoxProps, Divider, DividerProps, Heading, HStack, Skeleton, Stack } from '@chakra-ui/react';
import { FC, ReactElement, ReactNode } from 'react';
import { BeatLoader } from 'react-spinners';

import { Card } from './Card';

interface ContentCardProps extends BoxProps {
  contentDescription?: ReactNode;
  dividerBorderColor?: DividerProps['borderColor'];
  header?: ReactNode;
  headerAction?: ReactNode;
  icon?: ReactElement;
  isFetching?: boolean;
  isLoading?: boolean;
}

export const ContentCard: FC<ContentCardProps> = ({
  contentDescription,
  children,
  dividerBorderColor,
  header,
  headerAction,
  icon,
  isFetching,
  isLoading,
  w = 'full',
  ...boxProps
}) => {
  return (
    <Card {...boxProps}>
      <HStack spacing="4" py={4} px={4}>
        {isLoading ? <Skeleton height="20px" speed={2} fadeDuration={8} /> : icon}
        <Box width={'full'} ml={2}>
          {!isLoading ? (
            header && (
              <HStack justify="space-between" w="full">
                <Heading size="xs">{header}</Heading>
                {headerAction}
              </HStack>
            )
          ) : (
            <Skeleton height="20px" speed={2} fadeDuration={8} />
          )}
          {!isLoading ? (
            contentDescription && (
              <Box color="muted" fontSize="sm">
                {contentDescription}
              </Box>
            )
          ) : (
            <Skeleton height="20px" speed={2} fadeDuration={8} />
          )}
        </Box>
        {isFetching && <BeatLoader size={12} color={'#3F7DC1'} />}
      </HStack>
      <Divider borderColor={dividerBorderColor} />

      <Stack w={w} direction={['column']} p={6}>
        {isLoading ? <Skeleton height="500px" speed={2} fadeDuration={8} /> : children}
      </Stack>
    </Card>
  );
};
